module.exports = __webpack_public_path__ + "img/prolungato_laterale_sx.b4c1aac7.png";